import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'

const getRoleEmployees = async (token, params) => {
  const url = `roles/${params.role_id}/employees`

  const data = await apiGet({ url, token, params })
  return data
}

export function useRoleEmployees({ params, options = {} }) {
  const token = useContext(AuthContext)

  return useQuery(
    [`roles/${params.role_id}/employees`, params],
    () => getRoleEmployees(token, params),
    {
      ...options
    }
  )
}
